// extracted by mini-css-extract-plugin
export default {"mCard":"vD-z","image":"wD-z","imageNoBackground":"xD-z","imageHasCategory":"yD-z","fullWidth":"zD-z"};